import { Action } from 'redux';
import { OrderedMap } from 'immutable';

import { Currency } from '../../models/Hotels/Currency';

import { CURRENCIES_REQUEST, CURRENCIES_RESPONSE, CURRENCIES_ERROR, SET_CURRENCY } from '../../actions/Hotels/currencies';

export interface HotelsCurrenciesState {
    currencies: OrderedMap<number, Currency>;
    loadingCurrencies: boolean;
    errorCurrencies: any;

    currency: Currency;
}

const initialState: HotelsCurrenciesState = {
    currencies: OrderedMap<number, Currency>(),
    loadingCurrencies: false,
    errorCurrencies: null,

    currency: {} as Currency
};

export function hotelsCurrencyState(state: HotelsCurrenciesState = initialState, action: Action) {
    switch (action.type) {
        case CURRENCIES_REQUEST: {
            return {
                ...state,
                currencies: initialState.currencies,
                loadingCurrencies: true,
                errorCurrencies: initialState.errorCurrencies
            };
        }
        case CURRENCIES_RESPONSE: {
            const result: Array<Currency> = (action as any).response.result;
            const currencies = result.reduce((prev, cur) => prev.set(cur.id, cur), initialState.currencies);
            return {
                ...state,
                currencies,
                loadingCurrencies: false
            };
        }
        case CURRENCIES_ERROR: {
            const errorCurrencies = (action as any).error;
            return {
                ...state,
                loadingCurrencies: false,
                errorCurrencies
            };
        }
        case SET_CURRENCY: {
            const currency = (action as any).currency;
            return {
                ...state,
                currency
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Hotels/currency.ts